<div class="app">
    <div class="app__content">
        <div class="app__content__main">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
